import { useForm } from '@mantine/form';
import { useState } from 'react';
import type { EditProductCostDto } from '../types/EditProductCostDto';

export function useEditProductCostForm(productStockLevel: EditProductCostDto) {
	const [inputs, setInputs] = useState<EditProductCostDto>(productStockLevel);

	const form = useForm<EditProductCostDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			caseCost: (value) => {
				if (!value) {
					return "Case cost cannot be empty"
				}
				if (value > 10000) {
					return 'Case cost cannot be larger than 10,000';
				}

				if (value === 0) {
					return 'Case cost cannot be 0';
				}

				if (value < 0) {
					return 'Case cost cannot be smaller than 0';
				}
			},
			caseQuantity: (value) => {
				if (!value) {
					return "Case quantity cannot be empty"
				}
				if (value > 10000) {
					return 'Case quantity cannot be larger than 10,000';
				}

				if (value === 0) {
					return 'Case quantity cannot be 0';
				}

				if (value < 0) {
					return 'Case quantity cannot be smaller than 0';
				}
			},
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}